import i18n from 'i18next';

import { config } from '@/config.ts';

const getNormalizedPathname = (pathname: string) => {
	return pathname.startsWith('/') ? `${pathname}` : `/${pathname}`;
};

export const getUrlToBackendApi = (pathname: string, baseUrl = window.location.href) => {
	const pathnamePrefix = config.BASE_API_URL;

	const url = new URL(`${pathnamePrefix}${getNormalizedPathname(pathname)}`, baseUrl);
	url.searchParams.append('lang', i18n.language);

	return url;
};
